import type {
  CreateLegalEntityDto,
  LegalEntity,
  UpdateLegalEntityDto,
} from '@carvia/ros-client-types';
import { Service } from './http-service';

class LegalEntitiesService extends Service<
  LegalEntity,
  CreateLegalEntityDto,
  UpdateLegalEntityDto
> {
  constructor() {
    super('/legal-entities');
  }
}

export const legalEntitiesService = new LegalEntitiesService();
